<div class="header flex justify-between items-center">
  <a class="back-button" (click)="handleBack()">
    @if (showBackButton()) {
      <svg width="24" height="10" viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.59961 9L1.59961 5L5.59961 1M1.59961 5H22.3996H1.59961Z"
          stroke="#333333"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    }
  </a>
  <span class="title weight-bold font-s uppercase text-overflow-ellipsis">{{ headerTitle() }}</span>
  <a class="close-button" (click)="handleClose()">
    <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 10.074L0.758923 10.834L5 6.5934L9.24108 10.834L10 10.074L5.7595 5.83398L10 1.59398L9.24108 0.833984L5 5.07457L0.758923 0.833984L0 1.59398L4.2405 5.83398L0 10.074Z"
        fill="#333333"
      />
    </svg>
  </a>
</div>
